import React, { useState, useEffect } from "react";
import axios from "axios";
import "./Submissions.css";

import fetchFromAPI from "../utils/fetchFromAPI";
import { formatDeadline } from "../utils/deadline";

import SubmissionList from "../components/SubmissionList";

const Submissions = () => {
  const [challengeInfo, setChallengeInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [submissions, setSubmissions] = useState([]);
  const [submissionStats, setSubmissionStats] = useState({
    total: 0,
    firstTime: 0,
  });

  useEffect(() => {
    // Fetch challenge info
    const fetchChallengeInfo = async () => {
      try {
        const response = await fetchFromAPI("/api/rules");
        setChallengeInfo(response.data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching challenge info:", error);
        setLoading(false);
      }
    };

    // Fetch submission stats
    const fetchSubmissions = async () => {
      try {
        const response = await fetchFromAPI("/api/submissionsform");
        const submissions = response.data;
        setSubmissions(submissions);

        // Calculate stats
        const stats = {
          total: submissions.length,
          firstTime: submissions.filter((sub) => sub.isFirstTimeFilmmaker)
            .length,
        };

        setSubmissionStats(stats);
      } catch (error) {
        console.error("Error fetching submission stats:", error);
        // Handle auth error gracefully
        if (error.response?.status === 401 || error.response?.status === 403) {
          console.log("Authentication required for viewing submission stats");
        }
      }
    };

    fetchChallengeInfo();
    fetchSubmissions();
  }, []);

  return (
    <div className="submissions-page">
      <h1 className="page-title">Film Submissions</h1>

      {!loading && challengeInfo && (
        <div className="current-challenge-info">
          <h2>
            Current Challenge: Season {challengeInfo.season}, Challenge{" "}
            {challengeInfo.challenge}
          </h2>
          <div className="challenge-details">
            <div className="challenge-rule">
              <span className="rule-label">Form:</span>
              <span className="rule-value">{challengeInfo.form}</span>
            </div>
            <div className="challenge-rule">
              <span className="rule-label">Wildcard:</span>
              <span className="rule-value">{challengeInfo.wildcard}</span>
            </div>
            <div className="challenge-rule">
              <span className="rule-label">Deadline:</span>
              <span className="rule-value">
                {formatDeadline(challengeInfo.due_date) ?? "Not available"}
              </span>
            </div>
          </div>
        </div>
      )}

      {/* <div className="admin-options">
        <div className="admin-actions">
          <h3>Admin Actions</h3>
          <button className="admin-button export-button">Export to CSV</button>
          <button className="admin-button archive-button">Archive All</button>
        </div>

        <div className="view-options">
          <h3>View Options</h3>
          <div className="view-toggles">
            <label className="toggle-option">
              <input type="checkbox" defaultChecked={true} />
              <span>Current Challenge Only</span>
            </label>
            <label className="toggle-option">
              <input type="checkbox" defaultChecked={true} />
              <span>Show Archived</span>
            </label>
          </div>
        </div>
      </div> */}

      <div className="submission-stats">
        <div className="stat-card">
          <div className="stat-number">{submissionStats.total}</div>
          <div className="stat-label">Total Submissions</div>
        </div>
        <div className="stat-card">
          <div className="stat-number">{submissionStats.firstTime}</div>
          <div className="stat-label">First-time Filmmakers</div>
        </div>
      </div>

      <div className="submissions-list-wrapper">
        <SubmissionList loading={loading} submissions={submissions} />
      </div>
    </div>
  );
};

export default Submissions;
